import { render, staticRenderFns } from "./UnusedTickets.vue?vue&type=template&id=1956990d&"
import script from "./UnusedTickets.vue?vue&type=script&lang=js&"
export * from "./UnusedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports